<template>
  <app-modal @close="close" class="stages-edit">
    <app-modal-default @close="close">
      <template slot="header">
        {{ $ml.get(`Edit stage`) }}
      </template>
      <template slot="content">
        <form class="body" @submit="save">
          <div class="data">
            <div class="top-panel">
              <app-text-input
                :label="$ml.get(`Stage name`)"
                v-model="stage.name"
                class="name"
                required
              />
              <app-text-input
                :label="$ml.get(`AVG. DURATION`)"
                v-model.number="duration.value"
                type="number"
                class="duration"
                required
                :min="$store.getters['crop/base'].type == 'soil-grown' ? 1 : 0"
              />
              <app-text-input
                label="pH"
                v-model.number="ph.value"
                type="number"
                required
                v-if="$store.getters['crop/base'].type != 'soil-grown'"
                max="14"
                class="ph"
              />

            </div>
            
            <div class="nutrients">
              <app-text-input
                v-model.number="getDataRowByNutrient(item.key).value"
                v-for="item in nuts"
                :key="item.key"
                :label="item.label"
                type="number"
                v-if="getDataRowByNutrient(item.key)"
                min="0"
                max="999"
              />
            </div>

          </div>
          <div class="bot-panel">
            <app-checkbox
              v-model="stage.noNutrientsNeeded"
              :label="$ml.get(`No nutrient needed`)"
              v-if="$store.getters['crop/base'].type == 'soil-grown'"
            ></app-checkbox>
            <app-btn
              @click="save"
              class="create"
              type="submit"
              :disabled="!canSave && !stage.noNutrientsNeeded"
            >{{$ml.get(`save`)}}</app-btn>
          </div>
        </form>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      stage: {},
      data: {}
    }
  },

  computed: {
    ...mapGetters({
      parent: 'crop/method',
      nuts: 'nutrients/cropNutrients',
    }),

    duration() {
      if(this.stage) {
        return this.stage.data.find(n => n.key === 'duration');
      }
    },

    gdd() {
      if(this.stage) {
        return this.stage.data.find(n => n.key === 'gdd');
      }
    },

    ph() {
      if(this.stage) {
        if(!this.stage.data.find(n => n.key === 'ph'))
          this.stage.data.push({ key: 'ph', label: 'pH', value: null, is_nutrient: false })
        return this.stage.data.find(n => n.key === 'ph');
      }
    },

    canSave() {
      let data = this.stage.data.filter(x => x.is_nutrient == true && x.value);
      let sum = 0;
      data = data.map(el => {
        sum += +el.value;
        return { val: el.value }

      })

      return sum ? true : false;
    },
  },

  props: {
    item: {},
  },

  created() {
    this.stage = _.cloneDeep(this.item);
    this.data = JSON.parse(JSON.stringify(this.stage))
    this.data.data.filter(el => el.is_nutrient && el.value).forEach(e => e.value = this.$store.getters['unit/convert']('kg/ha', e.value))
  },

  methods: {


    getDataRowByNutrient(key) {
      return this.data.data.find(n => n.name == key)
    },


    save(e) {
      e.preventDefault();
      let data = JSON.parse(JSON.stringify(this.data));
      data.data.filter(x => x.is_nutrient && x.value).forEach(e => e.value = this.$store.getters['unit/unConvert']('kg/ha', e.value));
      return API.crop.updateCropStage(this.stage.id, data).then(res => {
        this.updateParentList();
        this.close();
      });
    },


    updateParentList() {
      this.$emit('update');
    },


    close() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>

.stages-edit {

  .app-modal-default {
    max-width: 700px;
  }

  .body {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 10px 30px;
    padding-top: 30px;

    display: flex;
    flex-direction: column;
  }

  .data {
    flex-grow: 1;

    .top-panel {
      display: flex;
      flex-direction: row;
      padding-bottom: 30px;

      .name {
        margin-right: 30px;
      }

      .duration {
        margin-right: 30px;
        flex-basis: 350px;
      }

      .gdd {
        flex-basis: 350px;
      }
      .ph {
        flex-basis: 100px;
      }
    }

    .nutrients {

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-right: -16px;
      margin-left: -16px;
      .text-input {
        flex-basis: calc(20% - 32px);
        min-width: 70px;
        height: 50px;
        margin: 8px 16px 32px;
      }
    }
  }

  .bot-panel {
    width: 100%;
    padding-top: 10px;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .create {
      margin-left: 20px;
    }

    .delete {
      margin-left: 20px;
    }
  }
  @media (max-width: 768px) {
    .body {
      padding: 16px 12px;
      .data {
        .top-panel {
          flex-direction: column;
          .duration, .gdd {
            flex-basis: unset;
            margin-top: 32px;
          }
        }
      }
    }
  }
}

</style>
